<template>
  <div style="display: flex; flex-direction: row">
    <div style="display: flex; flex-direction: row; margin-left: 20px">
      <div style="margin-right: 5px">是否合约商家</div>
      <el-select
        v-model="form.is_signed_contract"
        filterable
        style="width: 200px"
        placeholder="是否合约商家"
        :disabled="disabled"
        @change="Achange"
      >
        <el-option
          v-for="item in isSignedContractSupply"
          :key="Number(item.value)"
          :label="item.label"
          :value="Number(item.value)"
        >
        </el-option>
      </el-select>
    </div>
    <div style="display: flex; flex-direction: row; margin-left: 20px">
      <div style="margin-right: 5px">结算周期</div>
      <el-select
        v-model="form.settle_days"
        filterable
        style="width: 200px"
        placeholder="结算周期"
        :disabled="disabled"
        @change="Bchange"
      >
        <el-option
          v-for="item in supplySettleDays"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { isSignedContractSupply, supplySettleDays } from "../../../tool/const";
export default {
  props: {
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSignedContractSupply: isSignedContractSupply,
      supplySettleDays: supplySettleDays,
      form: {
        is_signed_contract: "",
        settle_days: "",
      },
    };
  },
  mounted() {
    let t = this.data.is_signed_contract
      ? Number(this.data.is_signed_contract)
      : "";
    let t1 = this.data.settle_days == "0" ? "" : this.data.settle_days;
    this.$set(this.form, "is_signed_contract", t);
    this.$set(this.form, "settle_days", t1);
    console.log(this.form);
  },
  methods: {
    Bchange(e) {
      this.form.settle_days = e;
      this.submit();
    },
    Achange(e) {
      this.form.is_signed_contract = e;
      this.submit();
    },
    submit() {
      this.$emit("returnData", this.form);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/supply/components/SupplySelect.vue